module.exports = __webpack_public_path__ + "img/slide-3-get-to-know.aee3ad7b.png";